import { render } from "./coin-history-page.html?vue&type=template&id=a3dc954e&scoped=true&ts=true"
import script from "./coin-history-page.vue?vue&type=script&lang=ts"
export * from "./coin-history-page.vue?vue&type=script&lang=ts"

import "./coin-history-page.scss?vue&type=style&index=0&id=a3dc954e&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3dc954e"]])

export default __exports__